import logoUrl from "@/assets/liftblick-logo.png";

interface LogoProps {
  className?: string;
  /** Kept for backwards compatibility - the image already contains the wordmark. */
  showWordmark?: boolean;
  /** Explicitly force the inverted (white) version. When not set, follows the site dark mode. */
  inverted?: boolean;
}

export function Logo({ className = "", inverted }: LogoProps) {
  const invertClasses = inverted
    ? "invert brightness-0"
    : inverted === false
    ? ""
    : "dark:invert dark:brightness-0";

  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src={logoUrl}
        alt="Liftblick.ch"
        width={384}
        height={96}
        {...{ fetchpriority: "high" }}
        decoding="async"
        className={`h-12 w-auto select-none ${invertClasses}`}
        draggable={false}
      />
    </span>
  );
}
